import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import Popover from "@mui/material/Popover";
import ForwardIcon from "@mui/icons-material/Forward";
import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import Swal from "sweetalert2";
import { ThemeProvider, createTheme } from "@mui/material";
import DownloadingSharpIcon from "@mui/icons-material/DownloadingSharp";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { common_axios } from "../../../../App";
import { toast } from "react-toastify";

import {
  Backdrop,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Autocomplete,
  Skeleton,
  CircularProgress,
} from "@mui/material";
import Loader from "../../../../components/Loader";

import { dateFormatter } from "../../../../helper/helper";
import ReceiptIcon from "@mui/icons-material/Receipt";

import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useSelector } from "react-redux";
import DateRangePickerr from "../../Dashboard/DateRangePicker";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import DownloadIcon from "@mui/icons-material/Download";
import { CSVLink, CSVDownload } from "react-csv";
import InfoIcon from "@mui/icons-material/Info";
import moment from "moment";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import RefreshIcon from "@mui/icons-material/Refresh";
import ProgressLoader from "./ProgressLoader";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
export default function DeliveryReports() {
  function LinearProgressWithLabel(props) {
    // console.log({ props });

    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "122px", mr: "auto", ml: "auto" }}>
          <LinearProgress
            //   color="green"className="mt-1"
            className="mt-1"
            sx={{
              "& .MuiLinearProgress-bar1Determinate": {
                backgroundColor: props.colorr,
              },
            }}
            variant="determinate"
            {...props}
          />
        </Box>
      </Box>
    );
  }

  LinearProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate and buffer variants.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired,
    color: PropTypes.number.isRequired,
  };

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [totalPage, setTotalPage] = useState();
  const [totalPageCount, settotalPageCount] = useState(0);
  const [downloadLoader, setDownloadLoader] = useState(false);

  const [anchorEll, setAnchorEll] = React.useState(null);

  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [date, setDate] = useState({
    startTime: null,
    endTime: null,
    newTime: null,
    type: "All",
    type1: "",
    msgRefNo: "",
    senderName: null,
    destinationCountry: "",
    mobileNo: "",
    disableButton: false,
    pageNo: 0,
    pageSize: 10,
    interval: true,
    refrenceName: "",
    hideShow: false,
    selectorType: null,
    resellerName1: "",
  });

  useEffect(() => {
    setDate({
      ...date,
      endTime: null,
    });
  }, [date.startTime]);

  // ...................................Theme Provider....................................//
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  // ......................Download Modal Open//////////////////////////////////////////////

  const [downloadModelOpen, setDownloadModel] = useState(undefined);
  // console.log("first", downloadModelOpen);
  const modelButtonDownload = useRef(null);
  const DownloadAction = async (cell) => {
    setDownloadModel(cell.row.original);
    await modelButtonDownload.current.click();
  };
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const modelButtonApprove = useRef(null);

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        Cell: (cell) => {
          // console.log("cell--", cell.row.index);
          return <>{cell.row.index + 1 + date?.pageNo * date?.pageSize}</>;
        },
      },
      {
        Header: "Refrence Name",
        accessor: "referenceName", // accessor is the "key" in the data
      },
      {
        Header: "Sender Id",
        accessor: "senderid", // accessor is the "key" in the data
      },
      {
        Header: "Destination Country",
        accessor: "destinationCountry", // accessor is the "key" in the data
      },
      {
        Header: "Message RefNo",
        accessor: "messageRefNo", // accessor is the "key" in the data
      },

      {
        Header: "Created Date",
        accessor: "requesteDate", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              <div>
                {cell?.row?.original?.requesteDate
                  ?.split(" ")
                  ?.map((dataaa) => {
                    return (
                      <>
                        <span>{dataaa}</span>
                        <br />
                      </>
                    );
                  })}
              </div>
            </>
          );
        },
      },
      {
        Header: "Start Date",
        accessor: "startDate", // accessor is the "key" in the data
        // Cell: (cell, row, index) => {
        //   return <>{dateFormatter(cell.row.original.startDate)}</>;
        // },
      },
      {
        Header: "End Date",
        accessor: "endDate", // accessor is the "key" in the data
        // Cell: (cell, row, index) => {
        //   return <>{dateFormatter(cell.row.original.endDate)}</>;
        // },
      },
      // {
      //   Header: "Info",

      //   accessor: "info", // accessor is the "key" in the data
      //   Cell: (cell, row, index) => {
      //     return (
      //       <>
      //         {
      //           <Tooltip
      //             onClick={() => {
      //               approveUserModal(cell);
      //             }}
      //             style={{ cursor: "pointer" }}
      //             placement="top"
      //             title={` Info of ${cell.row.original.voicePrompt}`}
      //           >
      //             <InfoIcon />
      //           </Tooltip>
      //         }
      //       </>
      //     );
      //   },
      // },

      // {
      //   Header: "Status",
      //   accessor: "status",
      //   Cell: (cell) => {
      //     return (
      //       <>
      //         {cell.row.original.status == 0 ? (
      //           <ProgressLoader />
      //         ) : cell.row.original.status == 1 ? (
      //           <div class="progress">
      //             <div
      //               class="progress-bar bg-success"
      //               role="progressbar"
      //               style={{ width: "100%" }}
      //               aria-valuenow="100"
      //               aria-valuemin="0"
      //               aria-valuemax="100"
      //             ></div>
      //           </div>
      //         ) : (
      //           <div className="badge badge_8 bg-success">Complete</div>
      //         )}
      //       </>
      //     );
      //   },
      // },

      // {
      //   Header: "Status",
      //   accessor: "status",
      //   Cell: (cell) => {
      //     return (
      //       <>
      //         {cell?.row?.original?.status == false ? (
      //           <>
      //             <p style={{ fontSize: "12px" }} className="process_txt">In Process</p>
      //             <ProgressLoader />
      //           </>
      //         ) : cell?.row?.original?.status == true ? (
      //           <>
      //             <p style={{ fontSize: "12px" }} className="text-center fw-bold">Completed</p>
      //             <LinearProgressWithLabel
      //               colorr={
      //                 cell?.row?.original?.status == true
      //                   ? "green"
      //                   : "blue"
      //               }
      //             />
      //           </>
      //         ) : (

      //           {
      //             /* <div className="badge badge_8 bg-success">Complete</div> */
      //           }
      //         )}
      //       </>
      //     );
      //   },
      // },

      {
        Header: "Download",

        Cell: (cell) => {
          return (
            <>
              {cell?.row?.original?.status == 0 ||
              (downloadModelOpen?.id === cell?.row?.original?.id &&
                downloadLoader == true) ? (
                <>
                  <Box
                    sx={{ display: "block", width: "100px" }}
                    className="mx-auto"
                  >
                    <CircularProgress
                      style={{ width: "31px", height: "31px" }}
                    />
                  </Box>
                </>
              ) : cell?.row?.original?.status == 1 ? (
                <>
                  <div className="text-center">
                    <button
                      className="btn color_1 px-2 text-center"
                      type="button"
                      id=""
                      data-bs-toggle=""
                      aria-expanded="false"
                      onClick={() => {
                        downloadFile(cell);
                      }}
                    >
                      <FileDownloadIcon />
                    </button>
                  </div>
                </>
              ) : (
                <div className="text-center">
                  <button
                    type="button"
                    className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center text-center"
                    id="btn_Update"
                    style={{ width: "auto" }}
                    onClick={() => {
                      DownloadAction(cell);
                    }}
                    // disabled={DownloadDisable}
                  >
                    {/* Download Request */}
                    <DownloadingSharpIcon />
                  </button>
                </div>
              )}
            </>
          );
        },
      },

      // {
      //   Header: "Download",
      //   Footer: "Download",

      //   Cell: (cell) => {
      //     return (
      //       <>
      //         {cell?.row?.original?.status == 0 ? (
      //           <></>
      //         ) : cell?.row?.original?.status == 1 ? (
      //           <>
      //             <div className="">
      //               <button
      //                 className="btn color_1 px-2"
      //                 type="button"
      //                 id=""
      //                 data-bs-toggle=""
      //                 aria-expanded="false"
      //                 onClick={() => {
      //                   downloadFile(cell);
      //                 }}
      //           //       onClick={() => {
      //           //   // window.location.href = `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}${cell.row.original.downloadpath}`;
      //           //   excelExport(cell);
      //           // }}
      //               >
      //                 <DownloadIcon />
      //               </button>
      //             </div>
      //           </>
      //         ) : (

      //           {
      //             /* <div className="badge badge_8 bg-success">Complete</div> */
      //           }
      //         )}
      //       </>
      //     );
      //   },
      // },
    ],
    [date]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const customId1 = "custom-id-yes";

  // console.log(date.start);
  useEffect(() => {
    if (totalPageCount > totalPage) {
      settotalPageCount(1);
    }
  }, [totalPageCount]);

  // ....................................Download File Url.............................................................//

  const downloadFile = async (cell) => {
    try {
      const response = await common_axios.get(
        `${cell?.row?.original?.downloadUrl}?UserId=${localStorage.getItem(
          "UserId"
        )}&Source="web"`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `excel-file.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      // console.error(error);
    }
  };
  // .....................................................................................................................//
  const filterdata1 = async (e) => {
    // settotalPageCount(0);
    e.preventDefault();
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/export/excel`,
        {
          fileDetailsRequest: {
            startDate: moment(date?.startTime?.$d).format("YYYY-MM-DD"),
            endDate: moment(date?.endTime?.$d).format("YYYY-MM-DD"),
            status: date?.type == "All" ? null : date?.type,
            messageRefNo: date?.msgRefNo == "" ? null : date?.msgRefNo,
            mobileNumber: date?.mobileNo == "" ? null : date?.mobileNo,
            destinationCountry: date?.destinationCountry,
            senderId: date?.senderName,
            refrenceName: date?.refrenceName,
          },
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setDate({
          startTime: null,
          endTime: null,
          newDate: null,
          type: "All",
          refrenceName: "",
          mobileNo: "",
          msgRefNo: "",
          senderName: null,
          destinationCountry: null,
          disableButton: false,
          pageNo: 0,
          pageSize: 10,
          interval: true,
        });

        // await toast.success(res.data.statusDescription.statusMessage, {
        //   theme: "colored",
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        fetchExcel();
        // if (date.interval) {
        //   fetchExcel();

        //   setDate({
        //     ...date,
        //     interval: false,
        //   });
        // }

        // await settotalPageCount(res?.data?.campaignCreation?.number);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // useEffect(() => {
  //   let inttVal;
  //   if (!date.interval) {
  //     inttVal = setInterval(() => {
  //       fetchExcel();
  //     }, 10000);
  //   }
  //   return () => {
  //     clearInterval(inttVal);
  //   };
  // }, [date.interval]);

  // useEffect(() => {
  //   first

  //   return () => {
  //     second
  //   }
  // }, [third])

  const fetchExcel = async () => {
    // settotalPageCount(0);
    try {
      setOpen1(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/get/All/file-details`,
        {
          pageNo: date?.pageNo,
          pageSize: date?.pageSize,
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        setOpen1(false);
        if (res.data?.fileDetails) {
          setData(res.data?.fileDetails?.content);
          setData1(res.data?.fileDetails);
        }
      } else {
        setOpen1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const searchApi = async () => {
    // settotalPageCount(0);
    try {
      setOpen1(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/search/file-details`,
        {
          pageNo: date?.pageNo,
          pageSize: date?.pageSize,
          senderId: date?.resellerName1 == "" ? null : date?.resellerName1,
          requesteDate: moment(date?.newTime).format("YYYY-MM-DD"),
          referenceName: date?.type1 == "" ? null : date?.type1,
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        setOpen1(false);
        if (res.data?.fileDetails) {
          setData(res.data?.fileDetails?.content);
          setData1(res.data?.fileDetails);
        }
      } else {
        setOpen1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    fetchExcel();
  }, [date.pageNo, date.pageSize]);

  const excelExport = async (cell) => {
    // console.log({ cell });
    try {
      setOpen(true);
      const res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/download/delivery-report/${cell?.row?.original?.fileName}`,

        {
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log(res.data);
      await setOpen(false);
      const filename = cell?.row?.original?.id;
      const filenamee = dateFormatter(cell?.row?.original?.endDate);
      // console.log({ filename });
      const url = window.URL.createObjectURL(new Blob([res.data])); // you can mention a type if you wish
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${filename}_${filenamee}.xlsx`); //this is the name with which the file will be downloaded
      // link.setAttribute("download", `${filename}`.xlsx); //this is the name with which the file will be downloaded
      link.click();
      // no need to append link as child to body.
      setTimeout(() => window.URL.revokeObjectURL(url), 0); // this is important too, otherwise we will be unnecessarily spiking memory!
    } catch (error) {
      // console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  const fetchSenderIds = async () => {
    try {
      setOpen(true);
      const res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/get/senderId`
      );
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        if (res.data?.sender) setData2(res.data.sender);

        // await settotalPageCount(res?.data?.campaignCreation?.number);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    fetchSenderIds();
  }, []);

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      {selectedUserDetailApprove != undefined && (
        <>
          <button
            type="button"
            ref={modelButtonApprove}
            class="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Launch static backdrop modal
          </button>

          <form>
            <div
              class="modal fade"
              id="staticBackdrop"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">
                      Prompt Information
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div className="row">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Cmapaign ID:
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.id}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>

                      <div className="col-md-6 ">
                        <label for="exampleInputEmail1" className="form-label">
                          Caller Id :
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.senderId}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mt-3">
                        <label for="exampleInputEmail1" className="form-label">
                          Campaign Name
                        </label>
                        <input
                          type="text"
                          disabled
                          value={
                            selectedUserDetailApprove?.eventName || "-------"
                          }
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                      <div className="col-md-6 mt-3">
                        <label for="exampleInputEmail1" className="form-label">
                          Queue Code
                        </label>
                        <input
                          type="text"
                          disabled
                          value={
                            selectedUserDetailApprove?.queueCode || "-------"
                          }
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                      <div className="col-md-6 mt-3">
                        <label
                          for="exampleInputEmail1"
                          className="form-label me-2"
                        >
                          Status
                        </label>
                        {selectedUserDetailApprove?.approvalStatus == 1 ? (
                          <>
                            <div className="badge badge_8 bg-success">
                              Approved
                            </div>
                          </>
                        ) : selectedUserDetailApprove?.approvalStatus == 2 ? (
                          <>
                            <>
                              <div className="badge badge_8 bg-danger">
                                Rejected
                              </div>
                            </>
                          </>
                        ) : (
                          <>
                            <div className="badge badge_8 bg-warning">
                              Pending
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}
      <div>
        <button
          // ref={modelButtonApprove}
          ref={modelButtonDownload}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop2"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal fade"
          id="staticBackdrop2"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdrop2Label"
          aria-hidden="true"
        >
          <div className="modal-dialog ">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdrop2Label">
                  Download Request
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                {/* Are you sure you want to download the report ? */}
                Are you sure you want to initiate the download request ?
              </div>

              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary shadow"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary editcolor shadow okbtn"
                  data-bs-dismiss="modal"
                  // onClick={() => {
                  //   DownloadButtonApi
                  // }}
                  // onClick={DownloadButtonApi}
                >
                  Download Request
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <ReceiptIcon style={{ fontStyle: "30px", color: "white" }} />
            </div>
            <div className=" marginleft_0 pt-1 ">
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                DeliveryReport
              </p>
            </div>
          </div>

          {/* {data.length > 0 ? ( */}

          <div className="card-body pb-0">
            <div className="card shadow-none border bg_blue">
              <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                Generate Report
              </span>

              <div className="card-body text-lg-start text-center">
                <>
                  <ThemeProvider theme={theme}>
                    <form onSubmit={filterdata1}>
                      <div className="row">
                        {/* <div className="col-md-2">
                        <TextField
                          style={{ cursor: "pointer" }}
                          disabled
                          className="w-100"
                          label="Reports From"
                          name="userName"
                          variant="outlined"
                          size="small"
                          type="text"
                         
                          helperText="DD-MM-YYYY"
                          value={selectedTime.start}
                          onClick={(event) => {
                            setAnchorEll(event.currentTarget);
                          }}
                        />
                      </div>
                      <div className="col-md-1">
                        <div className="text-center ">
                   
                          <PanToolAltIcon
                   
                            style={{
                              transform: "rotate(90deg)",
                            }}
                
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <TextField
                          style={{ cursor: "pointer" }}
                          disabled
                          className="w-100"
                          label="Reports To"
                          name="userName"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={selectedTime.end}
                          helperText="DD-MM-YYYY"
                         
                          onClick={(event) => {
                            setAnchorEll(event.currentTarget);
                          }}
                        />
                      </div>
                      <div className="col-md-2 ms-4">
                        <IconButton
                          variant="text"
                          size="small"
                         
                          sx={{
                            color: "#7B809A",
                          }}
                          aria-describedby={
                            Boolean(anchorEll) ? "simple-popover" : undefined
                          }
                          onClick={(event) => {
                            setAnchorEll(event.currentTarget);
                          }}
                        >
                          <CalendarMonthIcon
                            sx={{ color: "black", fontSize: "30px" }}
                          />
                        </IconButton>
                        <Popover
                          id={Boolean(anchorEll) ? "simple-popover" : undefined}
                          open={Boolean(anchorEll)}
                          anchorEl={anchorEll}
                          onClose={() => {
                            setAnchorEll(null);
                          }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                        >
                          <DateRangePickerr className="btn bg-gradient-primary m-0" />
                        </Popover>

                        
                      </div> */}

                        <div className="col-md-3">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack spacing={3}>
                              <DesktopDatePicker
                                required
                                maxDate={new Date()}
                                minDate={
                                  new Date(
                                    moment(new Date()).subtract(6, "months")
                                  )
                                }
                                label="Start Date"
                                inputFormat="DD/MM/YYYY"
                                value={date.startTime}
                                onChange={(e) => {
                                  setDate({
                                    ...date,

                                    startTime: e,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    size="small"
                                    {...params}
                                    onKeyDown={onKeyDown}
                                  />
                                )}
                              />
                            </Stack>
                          </LocalizationProvider>
                        </div>

                        <div className="col-md-3">
                          <LocalizationProvider
                            required
                            dateAdapter={AdapterDayjs}
                          >
                            <Stack spacing={3}>
                              <DesktopDatePicker
                                required
                                maxDate={new Date()}
                                disabled={!date.startTime}
                                minDate={date.startTime}
                                label="End Date"
                                inputFormat="DD/MM/YYYY"
                                value={date.endTime}
                                onChange={(e) => {
                                  setDate({
                                    ...date,
                                    endTime: e,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    onKeyDown={onKeyDown}
                                    size="small"
                                    {...params}
                                  />
                                )}
                              />
                            </Stack>
                          </LocalizationProvider>
                        </div>

                        <div className="col-md-3">
                          <TextField
                            required
                            className="w-100 me-3"
                            label="Reference Name"
                            name="senderId"
                            variant="outlined"
                            size="small"
                            type="text"
                            value={date.refrenceName}
                            onChange={(e) => {
                              setDate({
                                ...date,

                                refrenceName: e.target.value,
                              });
                            }}
                          />
                        </div>

                        <div className="col-md-3">
                          <Autocomplete
                            fullWidth
                            size="small"
                            disablePortal
                            id="combo-box-demo"
                            options={data2}
                            value={date.senderName}
                            onChange={(e, val) => {
                              setDate({
                                ...date,
                                senderName: val,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Sender Id"
                              />
                            )}
                          />
                        </div>

                        {/* <div className="text-end">
                        <CSVLink data={data}>
                          <Button
                            sx={{ borderRadius: "10px", fontSize: "10px" }}
                            startIcon={<CloudDownloadIcon />}
                            variant="outlined"
                            className="btn bg-gradient-primary m-0"
                          >
                            {" "}
                            To Excel
                          </Button>
                        </CSVLink>
                      </div> */}
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-3">
                          <TextField
                            className="w-100 me-3"
                            label="Message Ref No"
                            name="senderId"
                            variant="outlined"
                            size="small"
                            type="number"
                            value={date.msgRefNo}
                            onChange={(e) => {
                              setDate({
                                ...date,

                                msgRefNo: e.target.value,
                              });
                            }}
                          />
                        </div>

                        <div className="col-md-3">
                          <FormControl fullWidth>
                            <InputLabel size="small" id="test-select-label">
                              Destination Country
                            </InputLabel>
                            <Select
                              size="small"
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Destination Country"
                              value={date.destinationCountry}
                              onChange={(e) => {
                                setDate({
                                  ...date,

                                  destinationCountry: e.target.value,
                                });
                              }}
                            >
                              {[
                                // { id: 0, name: "All", value: null },
                                {
                                  id: 1,
                                  name: "United Arab Emirates",
                                  value: "United Arab Emirates",
                                },
                                {
                                  id: 2,
                                  name: "Bangladesh",
                                  value: "Bangladesh",
                                },
                                {
                                  id: 3,
                                  name: "India",
                                  value: "India",
                                },
                              ].map((d) => {
                                return (
                                  <MenuItem value={d.value}> {d.name}</MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="col-md-3">
                          <TextField
                            className="w-100 me-3"
                            label="Mobile No"
                            name="senderId"
                            variant="outlined"
                            size="small"
                            type="number"
                            value={date.mobileNo}
                            onChange={(e) => {
                              setDate({
                                ...date,

                                mobileNo: e.target.value,
                              });
                            }}
                          />
                        </div>

                        <div className="col-md-3">
                          <FormControl fullWidth>
                            <InputLabel size="small" id="test-select-label">
                              Status
                            </InputLabel>
                            <Select
                              size="small"
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Status"
                              value={date.type}
                              onChange={(e) => {
                                setDate({
                                  ...date,

                                  type: e.target.value,
                                });
                              }}
                            >
                              {[
                                // { id: 0, name: "All", value: null },
                                {
                                  id: 1,
                                  name: "All",
                                  value: "All",
                                },
                                {
                                  id: 2,
                                  name: "Messaged Sent",
                                  value: "Messaged Sent",
                                },
                                {
                                  id: 3,
                                  name: "Messaged Delivered",
                                  value: "Messaged Delivered",
                                },
                                {
                                  id: 4,
                                  name: "Messaged Not Delivered",
                                  value: "Messaged Not Delivered",
                                },
                              ].map((d) => {
                                return (
                                  <MenuItem value={d.value}> {d.name}</MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="text-end">
                          <button
                            disabled={date.disableButton}
                            className="btn dawnload_UP m-0"
                            type="submit"
                          >
                            Generate Report
                          </button>
                        </div>
                      </div>
                    </form>
                  </ThemeProvider>
                </>
              </div>
            </div>
          </div>

          <div className="card-body pt-0">
            <div className="container-fluid p-0">
              <div className="card shadow-none border bg_blue mt-5">
                <span className="badge rounded-pill bg-primary mt-n3 ms-5 ">
                  Recently Generated
                </span>

                <div
                  className="d-flex justify-content-between mx-4 mt-2"
                  style={{ minHeight: "4rem", maxHeight: "4rem" }}
                >
                  <div className="my-auto">
                    {/* <IconButton onClick={fetchExcel}>
                      <RefreshIcon />
                    </IconButton> */}

                    <IconButton
                      variant="text"
                      size="small"
                      sx={{
                        color: "#7B809A",
                      }}
                      onClick={(event) => {
                        setDate({
                          ...date,
                          hideShow: !date.hideShow,
                        });
                      }}
                    >
                      {date.hideShow ? <CancelIcon /> : <SearchIcon />}
                    </IconButton>
                  </div>

                  <div className="d-flex flex-wrap justify-content-between my-auto">
                    {date.hideShow && (
                      <>
                        <div className="d-flex mx-3" style={{ width: "200px" }}>
                          <FormControl fullWidth>
                            <InputLabel size="small" id="test-select-label">
                              Select Search Category
                            </InputLabel>
                            <Select
                              size="small"
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={date.selectorType}
                              label="Select Search Category"
                              onChange={(e) => {
                                setDate({
                                  ...date,
                                  selectorType: e.target.value,
                                  resellerName1: "",
                                  type1: "",
                                  newTime: null,
                                });
                              }}
                            >
                              {[
                                {
                                  id: 0,
                                  name: "Sender Id",
                                  value: "Sender Id",
                                },
                                {
                                  id: 1,
                                  name: "Creation Date",
                                  value: "Start Date",
                                },

                                {
                                  id: 2,
                                  name: "Reference Name",
                                  value: "Type",
                                },
                              ].map((d) => {
                                return (
                                  <MenuItem key={d.id} value={d.value}>
                                    {" "}
                                    {d.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="d-flex">
                          {date.selectorType == "Sender Id" ? (
                            <TextField
                              required
                              className="w-100 me-3"
                              label="Sender Id"
                              name="senderId"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={date.resellerName1}
                              onChange={(e) => {
                                setDate({
                                  ...date,

                                  resellerName1: e.target.value,
                                });
                              }}
                            />
                          ) : null}

                          {date.selectorType == "Type" ? (
                            <div
                              className="d-flex justify-content-between mx-3"
                              style={{ width: "200px" }}
                            >
                              <TextField
                                required
                                className="w-100 me-3"
                                label="Reference Name"
                                name="senderId"
                                variant="outlined"
                                size="small"
                                type="text"
                                value={date.type1}
                                onChange={(e) => {
                                  setDate({
                                    ...date,

                                    type1: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          ) : null}

                          {date.selectorType == "Start Date" ? (
                            <div
                              className="d-flex justify-content-between mx-3"
                              style={{ width: "200px" }}
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Stack spacing={3}>
                                  <DesktopDatePicker
                                    required
                                    maxDate={new Date()}
                                    minDate={
                                      new Date(
                                        moment(new Date()).subtract(6, "months")
                                      )
                                    }
                                    label="Start Date"
                                    inputFormat="DD/MM/YYYY"
                                    value={date.newTime}
                                    onChange={(e) => {
                                      setDate({
                                        ...date,

                                        newTime: e,
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        required
                                        size="small"
                                        disabled={true}
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                          readOnly: true,
                                        }}
                                      />
                                    )}
                                  />
                                </Stack>
                              </LocalizationProvider>
                            </div>
                          ) : null}

                          <div className="d-flex justify-content-between">
                            <button
                              disabled={
                                date.type1 == "" &&
                                (date.resellerName1 == null ||
                                  date.resellerName1 == "") &&
                                date?.newTime == null
                              }
                              onClick={searchApi}
                              className={
                                date.type1 == "" &&
                                (date.resellerName1 == null ||
                                  date.resellerName1 == "") &&
                                date?.newTime == null
                                  ? "btn btn-secondary mb-0"
                                  : "btn btn-primary mb-0"
                              }
                            >
                              <FilterAltIcon />
                            </button>
                          </div>
                          <div className="d-flex justify-content-between ms-3">
                            <button
                              onClick={() => {
                                setDate({
                                  ...date,
                                  selectorType: null,
                                  resellerName1: "",
                                  type1: "",
                                  newTime: null,
                                });
                              }}
                              className="btn resetBtn_UP mb-0"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="my-auto">
                    <Tooltip title="Refresh">
                      <button
                        type="submit"
                        className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                        // onClick={RefreshBtn}
                        onClick={() => fetchExcel("Text to Copy")}
                      >
                        {/* <i class="material-icons opacity-10">refresh</i> */}
                        <RefreshIcon />
                      </button>
                    </Tooltip>
                  </div>
                </div>

                {open1 ? (
                  <div className="container-fluid">
                    <Skeleton animation="wave" className="mt-3" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                  </div>
                ) : (
                  <>
                    {data.length > 0 ? (
                      <div className="p-4 pt-0">
                        <div className="d-flex justify-content-between my-3"></div>

                        <div className="table-responsive">
                          <table
                            {...getTableProps()}
                            id="example"
                            className="table table-striped table-bordered dataTable table-sm"
                            style={{ width: "100%" }}
                          >
                            <thead>
                              {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                  {headerGroup.headers.map((column) => (
                                    <th
                                      {...column.getHeaderProps(
                                        column.getSortByToggleProps()
                                      )}
                                      className="text-center width_2"
                                    >
                                      {column.render("Header")}
                                      <span>
                                        {column.isSorted
                                          ? column.isSortedDesc
                                            ? "↑"
                                            : "↓"
                                          : ""}
                                      </span>
                                    </th>
                                  ))}
                                </tr>
                              ))}
                            </thead>
                            <tbody class='onhover_change' {...getTableBodyProps()}>
                              {page.map((row) => {
                                prepareRow(row);
                                return (
                                  <tr {...row.getRowProps()}>
                                    {row.cells.map((cell) => {
                                      return (
                                        <td
                                          {...cell.getCellProps()}
                                          //           className={
                                          //   (cell.column.Header == "Sender Id" ||
                                          //     cell.column.Header == "Message RefNo" ||
                                          //     cell.column.Header == "Created Date"
                                          //     ||
                                          //     cell.column.Header == "Start Date" ||
                                          //     cell.column.Header == "End Date" ) &&
                                          //   "text-end"
                                          // }

                                          className={
                                            cell.column.Header == "Sender Id" ||
                                            cell.column.Header ==
                                              "Message RefNo"
                                              ? "text-end"
                                              : cell.column.Header ==
                                                  "Status" ||
                                                cell.column.Header == "Download"
                                              ? "text-center"
                                              : "text-start"
                                          }

                                          // className="text-center"
                                        >
                                          {cell.render("Cell")}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>

                        <div className="d-flex justify-content-between mt-3">
                          <div>
                            <span>
                              Page:
                              <strong>
                                {data1?.pageable?.pageNumber + 1} of{" "}
                                {data1?.totalPages}
                              </strong>
                            </span>
                          </div>

                          {/* <div>
                            <span>
                              Go to Page :
                              <input
                                type="number"
                                // defaultValue={pageIndex + 1}
                                // value={data1?.pageable?.pageNumber + 1}
                                value={date?.pageNo + 1}
                                onChange={(e) => {
                                  if (
                                    e.target.value > 0 &&
                                    e.target.value < data1?.totalPages + 1
                                  ) {
                                    const pageNumber = e.target.value
                                      ? Number(e.target.value) - 1
                                      : 0;
                                    setDate({
                                      ...date,
                                      pageNo: pageNumber,
                                    });
                                  }
                                }}
                                style={{ width: "50px" }}
                              />
                            </span>
                          </div> */}

                          <div>
                            <button
                              className="btn btn_primary "
                              type="button"
                              style={{ background: "#2C97D4" }}
                              disabled={data1?.pageable?.pageNumber == 0}
                              onClick={() => {
                                setDate({
                                  ...date,
                                  pageNo: date.pageNo - 1,
                                });
                              }}
                            >
                              Prev
                            </button>

                            <button
                              className="btn btn_primary ms-2"
                              type="button"
                              style={{ background: "#2C97D4" }}
                              disabled={
                                data1?.totalPages ==
                                data1?.pageable?.pageNumber + 1
                              }
                              onClick={() => {
                                setDate({
                                  ...date,
                                  pageNo: date.pageNo + 1,
                                });
                              }}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        {data?.length == 0 && open1 ? null : (
                          <div className="text-center mt-4">
                            <h5>No Record Found..!!</h5>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
